(function() {
    const ContattiService = function(
        $http,
        CONSTANTS
    ) {
        this.listaPrefissi = [];
        
        this.getPrefissi = () => {
            return $http.get(
                '/MSF-PRACTICEMANAGER-MF/api/Fea/RecuperaPrefissiTelefoniciInternazionali'
            );
        };

        this.getCertificazioneContatto = (ndg) => {
            return $http.get(
                CONSTANTS.REST_ROOT + CONSTANTS.REST.MITO.CERTIFICAZIONE + ndg
            );
        };
    };

    ContattiService.$inject = [
        '$http',
        'Mitom_CONSTANTS'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomContattiService', ContattiService);
})();